import { useRef } from "react";

import { 
  Box,
  Flex,
  Heading,
  Image,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverBody,
  PopoverArrow,
  Portal,
  Spacer,
  Text,
  useBreakpointValue,
  useDisclosure,
  useOutsideClick
} from "@chakra-ui/react";

import "react-big-calendar/lib/css/react-big-calendar.css";

export const CustomEvent = ({ event }) => {
  const { isOpen, onToggle, onClose } = useDisclosure();
  const popoverRef = useRef(null)
  useOutsideClick({
    ref: popoverRef,
    handler: onClose,
  })

  const isMobile = useBreakpointValue(
    {
      "base": ()=> true,
      "xl": ()=>  false
    }
  );  

  const {setupId, setupName, slotStart, slotEnd, memberName, memberProfileImg, nonSetEventName, isSideEvent, showFreePlay} = event.title;

  const SetupTriggerDisplay = () => {
    if (
      setupId && ("" + setupId)?.length > 0 && 
      setupName && setupName?.length > 0
    ) {
      if (isMobile()) {
        return(
          <>
            <Text mb={4}>{setupId}:</Text>
          </>
        );
      }
      return (
        <>
          <Text mb={8}>{setupId} - {setupName}:</Text>
        </>

      )
    }
    return([]);
  }

  const PlayerTriggerDisplay = () => {
    if (!nonSetEventName) {
      if (memberName && memberName?.length > 0) {
          return(
            <Text color="#ffff86" filter="drop-shadow(0px 0px 4px #000000)">{memberName}</Text>
          );
      }
      return (
        <Text>Free</Text>
      )
    }
    return([]);
  }

  const BackgroundEventTriggerDisplay = () => {
    if (nonSetEventName && nonSetEventName?.length > 0) {
      return (
        <>
          <Heading size="sm" color={isSideEvent ? "#ff8e61" : "initial"} filter={isSideEvent ? "drop-shadow(0px 0px 4px #000000)" : "initial"}>{nonSetEventName}</Heading>
          {showFreePlay && (
            <Text>Free play</Text>
          )}
        </>
      );
    }
  }

  const SetupPopoverDisplay = () => {
    if (
      setupId && ("" + setupId)?.length > 0 && 
      setupName && setupName?.length > 0
    ) {
      return (
        <>
          <Heading size="sm">Setup {setupId}:</Heading>
          <Text>{setupName}</Text>
          <Text mb={4}>{slotStart} - {slotEnd}</Text>
        </>
      );
    }
    return ([]);
  }

  const PlayerPopoverImgDisplay = () => {
    if (!nonSetEventName) {
      if (memberProfileImg && memberProfileImg?.length > 0) {
        return (
          <>
            <Image borderRadius={5} ml="auto" mr="auto" width="50px" src={memberProfileImg} />
          </>
        );
      }
    }
    return([]);
  };

  const PlayerPopoverNameDisplay = () => {
    if (!nonSetEventName) {
      if (memberName && memberName?.length > 0) {
        return (
          <>
            <Heading size="sm" color="#ffff86" filter="drop-shadow(0px 0px 4px #000000)">{memberName}</Heading>
          </>
        );
      }
      return(
        <><Text>Slot Available</Text></>
      )
    }
    return([]);
  };

  const BackgroundEventPopoverDisplay = () => {
    if (nonSetEventName && nonSetEventName?.length > 0) {
      return (
        <>
          <Heading size="sm" mb={4} color={isSideEvent ? "#ff8e61" : "initial"} filter={isSideEvent ? "drop-shadow(0px 0px 4px #000000)" : "initial"}>{nonSetEventName}</Heading>
          <Text mb={4}>{slotStart} - {slotEnd}</Text>
          {showFreePlay && (
            <Text>Free play</Text>
          )}
        </>
      );
    }
  }

  // it didn't like it when I tried to do the custom-event thing as a distinct component for whatever reason
  // (so don't do that)

  return(
    <Popover trigger={isMobile() ? "click" : "hover"}>
        <PopoverTrigger>
          <Box width="100%" height="100%" className="custom-event" style={event.style} >
            <SetupTriggerDisplay/>
            <PlayerTriggerDisplay/>
            <BackgroundEventTriggerDisplay/>
          </Box>
        </PopoverTrigger>
        <Portal>
          <PopoverContent>
              <PopoverArrow/>
              <PopoverBody>
                <SetupPopoverDisplay/>
                <Flex gap="15px" alignItems="anchor-center">
                  <PlayerPopoverImgDisplay/>
                  <PlayerPopoverNameDisplay/>
                  <Spacer/>
                </Flex>
                <BackgroundEventPopoverDisplay/>
              </PopoverBody>
          </PopoverContent>
        </Portal>
    </Popover>
  );
};